import { Field } from '../../Field'

import * as styles from './SettingsField.module.css'

function SettingsField({
  className = styles.SettingsField,
  fieldInputClassName = styles.fieldInput,
  labelClassName = styles.label,
  ...restProps
}) {
  return (
    <Field
      {...restProps}
      className={className}
      fieldInputClassName={fieldInputClassName}
      labelClassName={labelClassName}
    />
  )
}

export default SettingsField
